import script from "./Footer.vue?vue&type=script&setup=true&lang=js"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=3f5727f3&lang=css"
import "./Footer.vue?vue&type=style&index=1&id=3f5727f3&lang=scss&scoped=true"

import exportComponent from "/Users/kexikui/Desktop/code/dlmk/dlmk-mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f5727f3"]])

export default __exports__